import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress cross-origin iframe errors from analytics scripts (PostHog) in dev
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('cross-origin')) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

const rootElement = document.getElementById("root");

// react-snap: use hydrate if pre-rendered HTML exists
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement,
    <React.StrictMode><App /></React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode><App /></React.StrictMode>
  );
}
